import { render, staticRenderFns } from "./DashboardReload.vue?vue&type=template&id=1ac16608&scoped=true"
import script from "./DashboardReload.vue?vue&type=script&lang=js"
export * from "./DashboardReload.vue?vue&type=script&lang=js"
import style0 from "./DashboardReload.vue?vue&type=style&index=0&id=1ac16608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac16608",
  null
  
)

export default component.exports